export var PackagesFlightShopStep;
(function (PackagesFlightShopStep) {
    PackagesFlightShopStep[PackagesFlightShopStep["ChooseDeparture"] = 0] = "ChooseDeparture";
    PackagesFlightShopStep[PackagesFlightShopStep["ChooseReturn"] = 1] = "ChooseReturn";
})(PackagesFlightShopStep || (PackagesFlightShopStep = {}));
export var SearchPackagesRequestEnum;
(function (SearchPackagesRequestEnum) {
    SearchPackagesRequestEnum["FollowUpRequest"] = "FollowUpRequest";
    SearchPackagesRequestEnum["InitialRequest"] = "InitialRequest";
})(SearchPackagesRequestEnum || (SearchPackagesRequestEnum = {}));
export var LodgingSortOrderEnum;
(function (LodgingSortOrderEnum) {
    LodgingSortOrderEnum["DistanceAscending"] = "DistanceAscending";
    LodgingSortOrderEnum["MostRecommended"] = "MostRecommended";
    LodgingSortOrderEnum["Price"] = "Price";
    LodgingSortOrderEnum["StarRating"] = "StarRating";
    LodgingSortOrderEnum["UserRating"] = "UserRating";
})(LodgingSortOrderEnum || (LodgingSortOrderEnum = {}));
export var DestinationEnum;
(function (DestinationEnum) {
    DestinationEnum["Lodging"] = "Lodging";
    DestinationEnum["Place"] = "Place";
})(DestinationEnum || (DestinationEnum = {}));
export var PackageShopResponseEnum;
(function (PackageShopResponseEnum) {
    PackageShopResponseEnum["Success"] = "Success";
    PackageShopResponseEnum["Failure"] = "Failure";
})(PackageShopResponseEnum || (PackageShopResponseEnum = {}));
export var SearchPackageResponseError;
(function (SearchPackageResponseError) {
    SearchPackageResponseError["NoFlightsFound"] = "NoFlightsFound";
})(SearchPackageResponseError || (SearchPackageResponseError = {}));
export var SearchPackagesResponseEnum;
(function (SearchPackagesResponseEnum) {
    SearchPackagesResponseEnum["FollowUpResponse"] = "FollowUpResponse";
    SearchPackagesResponseEnum["InitialResponse"] = "InitialResponse";
})(SearchPackagesResponseEnum || (SearchPackagesResponseEnum = {}));
export var SafePackageDetailsEnum;
(function (SafePackageDetailsEnum) {
    SafePackageDetailsEnum["SafeFlightLodgingPackageDetails"] = "SafeFlightLodgingPackageDetails";
})(SafePackageDetailsEnum || (SafePackageDetailsEnum = {}));
export var PackageLodgingAvailabilityEnum;
(function (PackageLodgingAvailabilityEnum) {
    PackageLodgingAvailabilityEnum["Availability"] = "Availability";
})(PackageLodgingAvailabilityEnum || (PackageLodgingAvailabilityEnum = {}));
export var PackageFetchDetailsEnum;
(function (PackageFetchDetailsEnum) {
    PackageFetchDetailsEnum["Flight"] = "Flight";
})(PackageFetchDetailsEnum || (PackageFetchDetailsEnum = {}));
export var PackageShopEnum;
(function (PackageShopEnum) {
    PackageShopEnum["Flights"] = "Flights";
    PackageShopEnum["Rooms"] = "Rooms";
})(PackageShopEnum || (PackageShopEnum = {}));
export var RequoteReasonEnum;
(function (RequoteReasonEnum) {
    RequoteReasonEnum["StayDatesMismatch"] = "StayDatesMismatch";
})(RequoteReasonEnum || (RequoteReasonEnum = {}));
export var PackagesEntryTypeEnum;
(function (PackagesEntryTypeEnum) {
    PackagesEntryTypeEnum["FLIGHT_LIST"] = "flight_list";
    PackagesEntryTypeEnum["FLIGHT_SEARCH"] = "flight_search";
    PackagesEntryTypeEnum["RECENTLY_SEARCHED_PACKAGE"] = "recently_searched_package";
})(PackagesEntryTypeEnum || (PackagesEntryTypeEnum = {}));
export var DiscountInfoEnum;
(function (DiscountInfoEnum) {
    DiscountInfoEnum["NoDiscount"] = "NoDiscount";
    DiscountInfoEnum["WithDiscount"] = "WithDiscount";
})(DiscountInfoEnum || (DiscountInfoEnum = {}));
//# sourceMappingURL=interfaces.js.map